const navbar = {
  packages: "Pakej", // translated 
  hotelPackages: "Pakej Hotel", // translated 
  experiences: "Pengalaman", // translated 
  close: "Tutup", // translated 
  hotDeals: "Tawaran Hangat", // translated 
  dashboard: "Papan Pemuka", // translated 
  pricing: "Penentuan harga", // translated 
};








export default navbar;
